import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function Safety() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
      </header>
      </div>
    </main>
   <main className="terms-container faq  terms-nd-condition my-3">
       <div  className={`container ${styles.container}`}>
       <header className="terms-header">
         <h1 className='main-heading text-left'>ResuMate Child Safety & CSAM Prevention Standards</h1>
         <p>Last Updated: January 3, 2026</p>
         <p>
          ResuMate is committed to protecting the safety and well-being of all users. We maintain strict standards to prevent child sexual abuse and exploitation (CSAE), detect and report child sexual abuse material (CSAM), and ensure safe interactions between adult users. These standards apply to all users, content, and activity on ResuMate and are enforceable alongside our Terms of Use and Community Guidelines.
         </p>
       </header>

       <article>
         <h2 className='inner-heading'>1. Zero-Tolerance Policy for CSAM & Child Exploitation</h2>
         <p>ResuMate strictly prohibits:</p>
          <ul className='terms-list'>
           <li>Child sexual abuse material (CSAM)</li>
           <li>Sexualized content involving minors</li>
           <li>Grooming, enticement, or exploitation</li>
           <li>Attempts to contact minors for sexual purposes</li>
           <li>Any content that suggests, encourages, or normalizes sexual behavior involving minors</li>
         </ul>
         <p><strong>Enforcement:</strong></p>
          <ul className='terms-list'>
           <li>All violations result in immediate account removal</li>
           <li>Mandatory reporting to appropriate authorities</li>
           <li>Permanent banning for repeated or severe violations</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>2. Age Requirements</h2>
          <ul className='terms-list'>
           <li>ResuMate is strictly for users 18 years and older.</li>
           <li>Enforcement includes:
             <ul className='terms-list'>
               <li>Age-gating during account creation</li>
               <li>Automated and manual profile monitoring</li>
               <li>Mandatory removal and banning of suspected minor accounts</li>
               <li>Reporting attempted minor impersonation</li>
             </ul>
           </li>
           <li>Users may be required to provide proof of age if underage activity is suspected.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>3. CSAM Detection & Moderation</h2>
         <p>ResuMate employs multiple layers of detection:</p>
          <ul className='terms-list'>
           <li>Human moderator review and escalation</li>
           <li>Keyword and behavioral analysis filters</li>
           <li>Photo and content verification processes</li>
         </ul>
         <p><strong>Training & Oversight:</strong></p>
          <ul className='terms-list'>
           <li>Moderators receive ongoing training in CSAM identification and emerging threats.</li>
           <li>Enforcement is reviewed regularly to ensure compliance with legal and safety standards.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>4. Reporting CSAM to Authorities</h2>
         <p>ResuMate complies with all regional and national reporting laws. Upon detection of CSAM or attempted exploitation:</p>
          <ul className='terms-list'>
           <li>Content is removed immediately</li>
           <li>Accounts are suspended or banned</li>
           <li>Authorities are notified promptly</li>
           <li>ResuMate cooperates fully with law enforcement investigations</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>5. User Reporting of Safety Concerns</h2>
         <p>Users can report:</p>
          <ul className='terms-list'>
           <li>Underage users</li>
           <li>Suspicious or predatory behavior</li>
           <li>Sexual exploitation or grooming attempts</li>
           <li>Inappropriate content or CSAM</li>
         </ul>
         <p><strong>Reporting channels:</strong></p>
          <ul className='terms-list'>
           <li>In-app reporting: via any profile or message</li>
           <li>Email reporting: <a className='email'>sparklefromwithinllc@gmail.com</a></li>
         </ul>
         <p><strong>Response:</strong></p>
          <ul className='terms-list'>
           <li>All reports are reviewed promptly, and appropriate enforcement is taken</li>
           <li>Reports are treated confidentially, with privacy maintained to the extent possible</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>6. Behavior & Interaction Standards</h2>
         <p>The following are strictly prohibited:</p>
          <ul className='terms-list'>
           <li>Requesting sexual content from others</li>
           <li>Sharing sexual content involving minors</li>
           <li>Attempting to meet minors in person</li>
           <li>Harassment, threats, or coercive behavior</li>
           <li>Predatory, manipulative, or exploitative conduct</li>
         </ul>
         <p><strong>Consequences:</strong></p>
          <ul className='terms-list'>
           <li>Content removal</li>
           <li>Temporary or permanent account suspension</li>
           <li>Device blocking</li>
           <li>Reporting to law enforcement or relevant agencies</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>7. Enforcement & Escalation</h2>
         <p>Enforcement is proportional to the severity of the violation:</p>
          <ul className='terms-list'>
           <li>Minor / first-time violations: content removal, warning</li>
           <li>Serious violations: temporary suspension, permanent ban</li>
           <li>Severe or repeated violations: device blocking, law enforcement reporting</li>
         </ul>
         <p>ResuMate applies the strictest penalties for child safety violations.</p>
       </article>

       <article>
         <h2 className='inner-heading'>8. System Limitations & Force Majeure</h2>
          <ul className='terms-list'>
           <li>ResuMate uses automated and human moderation systems, but no system can guarantee complete detection of prohibited content.</li>
           <li>Users are responsible for reporting any concerns promptly.</li>
           <li>ResuMate is not liable for delays or failures in detection caused by events beyond its reasonable control, including:
             <ul className='terms-list'>
               <li>Natural disasters, power or internet outages</li>
               <li>App Store or platform disruptions</li>
               <li>Hosting or cloud service failures</li>
             </ul>
           </li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>9. Liability Disclaimer</h2>
          <ul className='terms-list'>
           <li>ResuMate is not responsible for actions taken by users attempting to bypass protections or engage in prohibited activity.</li>
           <li>Users remain fully responsible for their conduct, both online and offline.</li>
           <li>Violations of these Standards are also violations of ResuMate's Terms of Use and Community Guidelines.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>10. Continuous Improvement & Monitoring</h2>
          <ul className='terms-list'>
           <li>ResuMate regularly updates detection systems and moderation tools</li>
           <li>Safety policies and procedures are reviewed and audited periodically</li>
           <li>Moderators are trained on emerging threats and best practices</li>
           <li>Our commitment to child safety is ongoing and evolving</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>11. Compliance Statement</h2>
          <ul className='terms-list'>
           <li>ResuMate complies with all applicable child protection laws and industry standards</li>
           <li>CSAM and attempted exploitation are reported to regional and national authorities as required</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>12. Contact</h2>
         <p>For questions or concerns regarding child safety or CSAM prevention:</p>
         <p>Email: <a className='email'>sparklefromwithinllc@gmail.com</a></p>
       </article>

       <footer className="terms-footer">
         © 2026 ResuMate. All rights reserved.
       </footer>
       </div>
     </main>
      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                 <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Safety;

